export enum TabIndex {
    UNPAID = 0,
    PAID = 1,
    OTHERS = 2,
}

export const MAX_PRIVATE_ITEMS = 3;
export const MAX_PRO_ITEMS = 8;
